import type { ScheduleTemplate } from '@snootsvet/shared'

export function templateLabel(template: Pick<ScheduleTemplate, 'name' | 'archivedAt'>): string {
  return template.archivedAt ? `${template.name} (archived)` : template.name
}

/**
 * Select items for a template picker: the active templates, plus the current choice if
 * it has since been archived, so an existing cell or shift still shows what it uses.
 */
export function templateOptions(
  templates: ScheduleTemplate[],
  selectedId?: string | null
): { label: string; value: string }[] {
  return templates
    .filter((t) => t.archivedAt === null || t.id === selectedId)
    .map((t) => ({ label: templateLabel(t), value: t.id }))
}
